import React from 'react';
import { motion } from 'framer-motion';
const costs = ['Serate passate a trasformare concetti metodologici complessi in spiegazioni comprensibili per gli studenti', 'Lezioni preparate all’ultimo momento perché non trovi materiale chiaro e pronto all’uso', 'Studenti disorientati che memorizzano definizioni senza capire come applicarle', 'Difficoltà quando bisogna spiegare la differenza tra metodi, disegni, variabili o tipi di campionamento', 'Fine settimana persi a creare attività, casi, valutazioni e materiali da zero'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-157" data-mp="1nztolxtmxag3">
      <div className="max-w-3xl mx-auto" data-id="element-158" data-mp="1o14sryqzsk7q">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-159" data-mp="1syn601c1lllj">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-160" data-mp="3nbwf3s0of539">
            Ti suona familiare?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border text-left md:text-center" data-id="element-161" data-mp="1u1lm12egvf67">
            Domenica, ore 23. Domani hai lezione di metodologia della ricerca. E
            stai ancora cercando un modo chiaro per spiegare la differenza tra
            ricerca quantitativa e qualitativa, costruire un buon problema di
            ricerca o mostrare agli studenti come passare dai dati a una
            conclusione realmente difendibile.
            <br data-id="element-162" data-mp="1p2heshb3rrii" />
            <br data-id="element-163" data-mp="1p30lt2z7svhr" />
            <span className="text-gold-light font-medium" data-id="element-164" data-mp="1p3k26f97vbto">
              Non è una questione di preparazione.
            </span>{' '}
            È che da anni devi lavorare con materiali sparsi, teoria densa,
            risorse troppo generiche e contenuti che devi riorganizzare
            completamente prima di poterli utilizzare in aula.
          </p>
        </motion.div>

        <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-165" data-mp="1t5ohct91jzv7">
          Il costo di non avere il materiale giusto:
        </h3>

        <ul className="space-y-4" data-id="element-166" data-mp="1y2onf45w52mb">
          {costs.map((point, i) => <motion.li key={point} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/40" data-id="element-167" data-mp="225l953qq9euh" data-mpi={i}>
              <span className="w-2 h-2 rounded-full bg-red-500 mt-2 shrink-0" aria-hidden="true" data-id="element-168" data-mp="1o625oo8v2roi" />
              <span className="text-gray-300" data-id="element-169" data-mp="qpwoij0y4rwu">{point}</span>
            </motion.li>)}
        </ul>

        <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-170" data-mp="vo6kuwyepyk1">
          <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-171" data-mp="o6i3alktz4p5">
            Basta regalare il tuo tempo libero. La competenza ce l’hai già. Ora
            ti serve lo strumento giusto.
          </p>
          <p className="text-xl mt-4 text-white" data-id="element-172" data-mp="e6raqpftyzrp">
            Organizza oggi il tuo intero percorso didattico.
          </p>
        </div>
      </div>
    </section>;
}